<template>
    <nav class="navbar">
        <div class="nav-container">
            <div class="nav-links">
                <div
                    v-for="(item, index) in navItems"
                    :key="index"
                    class="nav-item"
                    :class="{ active: $store.state.activeIndex === index }"
                    @click="setActive(index)"
                >
                    {{ $i18n.locale === "zh" ? item.name : item.en }}
                </div>
            </div>

            <div class="nav-utils">
                <div class="search-box">
                    <a-icon class="search-icon" type="search"/>
                    <input
                        type="text"
                        :placeholder="$t('queryPlaceholder')"
                        @keyup.enter="toquery"
                        v-model="queryData"
                        v-if="showSearch"
                    />
                </div>

                <div class="lang-switch" v-if="showLang" @click="toggleLanguage">
          <span
              :style="{
              color: $i18n.locale === 'zh' ? '#4169e2' : '#333',
              fontWeight: $i18n.locale === 'zh' ? 'bold' : 'normal',
            }"
          >中</span
          >
                    <span>/</span>
                    <span
                        :style="{
              color: $i18n.locale === 'en' ? '#4169e2' : '#333',
              fontWeight: $i18n.locale === 'en' ? 'bold' : 'normal',
            }"
                    >EN</span
                    >
                </div>
            </div>
        </div>
    </nav>
</template>

<script>
import {queryByName} from "@/api/datalist";
import {mapMutations} from "vuex";

export default {
    name: "NavBar",
    props: {
        navItems: {
            type: Array,
            default: () => [],
        },
        showSearch: {
            type: Boolean,
            default: false,
        },
        showLang: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            hoverIndex: null,
            currentLang: this.$i18n.locale,
            index: 0,
            queryData: ''
        };
    },
    mounted() {
        var locale = localStorage.getItem('locale');
        if (locale) {
            this.$i18n.locale = locale;
        }
    },
    methods: {
        ...mapMutations(['setQueryParam']),
        toquery() {
            console.log(this.queryData)
            this.setQueryParam(this.queryData)
            if (this.queryData) {
                queryByName({name: this.queryData}).then(res => {
                    this.$router.push({path: '/signal', query: {type: res[0].type}})
                })
            }
        },
        setActive(index) {
            // console.log('index',index)
            // this.$store.commit("setActiveIndex", index);
            this.$router.push({path: this.navItems[index].path})
        },
        toggleLanguage() {
            let locale = this.$i18n.locale === 'zh' ? 'en' : 'zh'
            this.$i18n.locale = locale;
            localStorage.setItem("locale", locale);
        },
    },
};
</script>

<style scoped>
.navbar {
    display: flex;
    justify-content: center;
    width: 100%;
    height: 54px;
    background: #ffffff;
    border-radius: 0px 0px 0px 0px;
}

.nav-container {
    width: 1200px;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.nav-links {
    display: flex;
    height: 100%;
    gap: 24px;
}

.nav-item {
    position: relative;
    min-width: 94px;
    line-height: 54px;
    text-align: center;

    font-family: Source Han Sans CN, Source Han Sans CN;
    font-weight: 400;
    font-size: 14px;
    color: #1d2129;
    font-style: normal;
    text-transform: none;
}

/* 悬停状态 */
.nav-item:hover::after,
    /* 激活状态 */
.nav-item.active::after {
    position: absolute;
    content: "";
    bottom: 8px;
    left: 50%;
    transform: translateX(-50%);
    height: 2px;
    width: 54px;
    background: #2b6cb0;
}

.nav-item:hover,
.nav-item.active {
    color: #4169e2;
    cursor: pointer;
    font-weight: 500;
}

.nav-utils {
    display: flex;
    align-items: center;
    gap: 24px;
}

.search-box {
    width: 300px;
    position: relative;
    background: #ffffff;
    border-radius: 99px 99px 99px 99px;
    border: 1px solid #d5d9e0;
    padding-left: 13px;
}

.search-box input {
    width: calc(100% - 60px);
    height: 32px;
    outline: none;
    border: none;
}

.search-icon {
    margin-top: 2px;
    margin-right: 14px;
}

.lang-switch {
    background: none;
    /* border: 1px solid #ddd; */
    /* border-radius: 4px; */
    padding: 0px 28px;
    cursor: pointer;
    font-size: 14px;
}

.lang-switch:hover {
    background: #f5f7fa;
}
</style>
